import * as types from '../mutation-types'

const state = {
  main: {
    callState: null,
    phoneNumber: '',
    isOpenPopup: false,
  }
}

const mutations = {
  [types.CHANGE_PHONE_NUMBER] (state, phoneNumber) {
    state.main.phoneNumber = phoneNumber
  },
  [types.OPEN_SOFT_PHONE] (state, isOpenPopup) {
    state.main.isOpenPopup = isOpenPopup
  },
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/softphone.js